var map = {
	"./amazon.png": "6d5d",
	"./americanas.png": "4ac7",
	"./casas-bahia.png": "dd91",
	"./flexy.png": "5a90",
	"./loja-integrada.png": "2b38",
	"./magalu.png": "767b",
	"./mercado-livre.png": "83a8",
	"./muven-cart.png": "21bd",
	"./nuvemshop.png": "c8c6",
	"./shein.png": "54c9",
	"./shopee.png": "2ecf",
	"./shopify.png": "378f",
	"./tiktok-shop.png": "dec6",
	"./tray.png": "dd92",
	"./vtex.png": "a4d3",
	"./wbuy.png": "dcde",
	"./woocommerce.png": "7e10"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c16c";